module.exports = __webpack_public_path__ + "static/media/BLUSH_6252.fb61965d.jpg";